// extracted by mini-css-extract-plugin
module.exports = {"centered":"Button_centered__2Efsi","leftIcon":"Button_leftIcon__zWn5r","rightIcon":"Button_rightIcon__1oTeN"};